module.exports = __webpack_public_path__ + "img/health30_7-9-2021.320dd16e.jpg";